<ion-card class="service-card ion-no-margin ion-margin-horizontal mart10">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col size="5">
        <img [src]="itemInfo?.img || imagePlaceholder" />
      </ion-col>

      <ion-col size="7" class="card-info">
        <ion-card-header
          class="ion-no-padding fs-3 mart6 ion-padding-horizontal"
        >
          <ion-card-title
            class="fs-3 font600 text-wrap ion-no-margin l-height21 card-primary-text-color"
          >
            {{ itemInfo?.title }}</ion-card-title
          >
          <p
            class="fs-2 ion-no-margin font500 location l-height17 line-1-clip card-secondary-text-color"
          >
            {{
              selectedLocation || "retail_list_card.multiple_locations"
                | translate
            }}
          </p>
          <p
            class="fs-2 ion-no-margin font500 card-secondary-text-color line-1-clip"
            *ngIf="
              selectedLocation &&
              itemInfo?.selectedLocation?.locationInfo?.operatingHours
            "
          ></p
        ></ion-card-header>

        <ion-card-content
          class="ion-no-padding ion-padding-horizontal"
          *ngIf="itemInfo?.origPrice || itemInfo?.finalPrice"
        >
          <ion-label>
            <p
              class="strike-price-color mar0 fs-2 font500 line-1-clip"
              *ngIf="itemInfo?.origPrice > itemInfo?.finalPrice"
            >
              {{ itemInfo?.origPrice | currency : itemInfo.currency }}
            </p>
            <p
              class="primary-price-color mar0 fs-3 font700 ion-no-margin line-1-clip"
            >
              {{ itemInfo?.finalPrice | currency : itemInfo.currency }}
            </p>
          </ion-label>
        </ion-card-content>

        <div class="rating ion-padding-horizontal" *ngIf="itemInfo?.rating">
          <ion-icon class="tertiary-icon-color" name="star" />
          <p class="secondary-text-color fs-3 font600 ion-no-margin">
            {{ itemInfo?.rating }}
          </p>
        </div>

        <div
          class="disco-chip"
          *ngIf=" itemInfo?.tag || itemInfo?.campaigns?.[0]?.offerTitle"
        >
          <ion-chip
            class="tertiary-chip ion-no-padding ion-no-margin fs-1 font500"
          >
            {{ itemInfo?.tag || itemInfo?.campaigns?.[0]?.offerTitle }}
          </ion-chip>
        </div>

        <ion-button
          class="secondary-btn fs-3 font500 select-button ion-padding-horizontal marb10"
          (click)="navigateFunction(itemInfo)"
          >{{
            itemInfo?.tierInfo?.buttonText || "retail_list_card.book_now_btn"
              | translate
          }}</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
